module.exports = __webpack_public_path__ + "static/media/advincula-logo-pwa@2x.84af1ff8.jpg";